import React from 'react';
import { useSelector } from 'react-redux';
import SocketContext from '../../../context/SocketContext';
function Input({message,setMessage,textRef,socket}){

    const { activeConversation } = useSelector((state) => state.chat);
    const onChangeHandler = (e) => {
      setMessage(e.target.value);
    };


    return (
        <div className='w-full'>
            <input type="text" className='dark:bg-dark_hover_1 dark:text-dark_text_1 outline-none h-[45px] w-full flex-1 rounded-lg ps-4'
            placeholder="اكتب رسالة"
            value={message}
            onChange={onChangeHandler}
            ref={textRef}
            >
            </input>
        </div>
    );
}

const InputWithSocket = (props) => (
    <SocketContext.Consumer>
      {(socket) => <Input {...props} socket={socket} />}
    </SocketContext.Consumer>
  );
  export default InputWithSocket;
